import {buildServerCall} from '../services/wcfService';
import {getConnection} from '../_shared/GWTBridge/invoke/genPage';

export function getGeneralLanguages() {
    const methodName = 'GeneralLanguages';
    const reason = 'Languages for template';

    return buildServerCall(methodName, {}, reason, false, getConnection);
}
